(() => {
  'use strict';
  if (!/^\/products\/zen-for-men-spa-package\/?$/.test(location.pathname)) return;
  const items = [
    { test: t => /upgrade/.test(t) && /(50.*80|80.min|80.minute)/.test(t) && /(deep tissue|massage)/.test(t), benefit: 'More time for focused muscle work.', key: 'upgrade' },
    { test: t => /rapid tension relief/.test(t), benefit: 'Target stubborn muscle tightness.', key: 'rapid' },
    { test: t => /cbd balm/.test(t), benefit: 'Extra comfort for targeted areas.', key: 'cbd' },
    { test: t => /sole revive/.test(t), benefit: 'Focused care for tired feet.', key: 'sole' },
    { test: t => /lunch for one|spa lunch|add lunch/.test(t), benefit: 'Recharge before heading out.', key: 'lunch' }
  ];
  const normalize = s => (s || '').replace(/\s+/g, ' ').toLowerCase().trim();
  const css = document.createElement('style');
  css.id = 'yc-zen-w3-benefits-css';
  css.textContent = [
    '.yc-zen-enhancements-v19{display:block!important;}',
    '.yc-zen-w3-trial .yc-w3-choice-row.yc-zen-w3-choice{display:grid;grid-template-columns:17px minmax(0,1fr);gap:0 10px;align-items:start;}',
    '.yc-zen-w3-trial .yc-w3-choice-row.yc-zen-w3-choice>input{grid-column:1;grid-row:1/3;margin-top:4px!important;}',
    '.yc-zen-w3-trial .yc-w3-choice-row.yc-zen-w3-choice>span:not(.yc-zen-w3-benefit){grid-column:2;grid-row:1;min-width:0;}',
    '.yc-zen-w3-trial .yc-w3-choice-row .yc-zen-w3-benefit{grid-column:2;grid-row:2;display:block;font-family:var(--yc-zen-font,"Figtree",Arial,sans-serif);font-size:12px;line-height:1.4;font-weight:400;font-style:normal;color:#77726c;opacity:1;margin:2px 0 0;}',
    '.yc-zen-w3-trial .yc-zen-w3-title{font-family:var(--yc-zen-font,"Figtree",Arial,sans-serif);font-size:12px;line-height:1.45;font-weight:600;letter-spacing:.09em;text-transform:uppercase;margin:0 0 9px;}'
  ].join('\n');
  document.head.appendChild(css);
  let current = null, observer = null, queued = false;
  function decorate(root) {
    const shell = root.closest('.yc-w3-options-shell');
    if (!shell || !root.classList.contains('loaded')) return;
    const seen = new Set();
    for (const row of root.querySelectorAll('.yc-w3-choice-row')) {
      const text = normalize([...row.querySelectorAll('span, label')].filter(el => !el.classList.contains('yc-zen-w3-benefit')).map(el => el.textContent).join(' ') || row.textContent);
      const item = items.find(x => x.test(text));
      if (!item) continue;
      seen.add(item.key);
      row.classList.add('yc-zen-w3-choice');
      let caption = row.querySelector(':scope > .yc-zen-w3-benefit');
      if (!caption) { caption = document.createElement('span'); caption.className = 'yc-zen-w3-benefit'; row.appendChild(caption); }
      if (caption.textContent !== item.benefit) caption.textContent = item.benefit;
    }
    if (!seen.size) return;
    shell.classList.add('yc-zen-w3-trial');
    const groupTitlePresent = [...root.querySelectorAll('.product-options-field-name')].some(el => normalize(el.textContent) === 'take recovery further');
    if (!groupTitlePresent && !root.querySelector(':scope > .yc-zen-w3-title')) {
      const heading = document.createElement('h3');
      heading.className = 'yc-zen-w3-title';
      heading.textContent = 'Take Recovery Further';
      root.insertBefore(heading, root.firstChild);
    }
    if (seen.size === items.length) {
      const heading = [...document.querySelectorAll('.rte h3')].find(x => normalize(x.textContent) === 'take recovery further' && !root.contains(x));
      const list = heading?.nextElementSibling;
      if (heading && list?.tagName === 'UL') { heading.hidden = true; list.hidden = true; }
    }
  }
  function tick() { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; if (current?.isConnected) decorate(current); else attach(); }); }
  function attach() {
    const root = document.querySelector('.yc-w3-options-shell .w3-product-options');
    if (!root) return;
    if (root !== current) {
      if (observer) observer.disconnect();
      current = root;
      observer = new MutationObserver(tick);
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    decorate(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true }); else attach();
  document.body.addEventListener('productOptionsLoadedJS', tick);
  document.addEventListener('shopify:section:load', attach);
})();
